import { ArrowDown, ArrowsDownUp, ArrowUp } from "@phosphor-icons/react";
import { useState } from "react";

export function DividerRow({ colSpan }: { colSpan: number }) {
	return (
		<tr aria-hidden="true" className="pointer-events-none">
			<td colSpan={colSpan} className="px-3 py-0">
				<div className="h-px bg-border/40" />
			</td>
		</tr>
	);
}

export function usePagination() {
	const [page, setPage] = useState(1);
	return { page, setPage };
}

export function SortIcon({
	field,
	ordering,
}: {
	field: string;
	ordering?: string;
}) {
	if (ordering === field)
		return <ArrowUp className="size-3.5 shrink-0" aria-hidden="true" />;
	if (ordering === `-${field}`)
		return <ArrowDown className="size-3.5 shrink-0" aria-hidden="true" />;
	return (
		<ArrowsDownUp className="size-3.5 shrink-0 opacity-40" aria-hidden="true" />
	);
}
